import { render, staticRenderFns } from "./koshaFolder.vue?vue&type=template&id=0b14773b"
import script from "./koshaFolder.vue?vue&type=script&lang=js"
export * from "./koshaFolder.vue?vue&type=script&lang=js"
import style0 from "./koshaFolder.vue?vue&type=style&index=0&id=0b14773b&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b14773b')) {
      api.createRecord('0b14773b', component.options)
    } else {
      api.reload('0b14773b', component.options)
    }
    module.hot.accept("./koshaFolder.vue?vue&type=template&id=0b14773b", function () {
      api.rerender('0b14773b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/kosha/koshaFolder.vue"
export default component.exports